<template lang="pug">
.container.col-centered
  .row
    .col-md-8.col-md-offset-2
      .panel.panel-default(style="background: #f8f9fa; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.03);")
        .panel-heading(style="padding: 24px 24px 8px 24px;")
          div.title-bar
            h2.main_title.mt-0.mb-1 MT Download
            div(style="display: flex;")
              button.btn.btn-default(style="margin-top: 15px; margin-right: 8px; margin-bottom: 15px; display: flex; align-items: center;" @click='showInstructions = true')
                span(style="display: inline-block; height: 18px; margin-right:3px") Help
                span.glyphicon.glyphicon-question-sign
              a.btn.btn-default(style="margin-top: 15px; margin-right: 15px; margin-bottom: 15px; display: flex; align-items: center;" href="https://drive.google.com/uc?export=download&id=1cwoWxK_yRPixEdPO3M5-RD_jxwTQ1VsT" download)
                span(style="display: inline-block; height: 18px; margin-right:3px") User Manual v1.0
                span.glyphicon.glyphicon-cloud-download
          p.text-muted.mb-0(style="margin-left: 15px; margin-right: 15px;") Download the latest MT Bootloader and Firmware for OS2 Pro and OS5 models.
        .panel-body(style="padding: 24px;")
          .form-group.col-12.mb-3(style="margin-left: 15px; margin-right: 15px;")
            label.control_label.col-12 Category:
            v-select.col-12(v-bind:value.sync='selectedCategory' v-bind:options='categoryOptions' @change="onCategoryChange" placeholder='Not Selected' style="width: 100%; min-width: 180px;")
          .form-group.col-12.mb-3(style="margin-left: 15px; margin-right: 15px;")
            label.control_label Model:
            v-select(v-bind:value.sync='selectedModel' v-bind:options='modelOptions' @change="onModelChange" search placeholder='Not Selected' style="width: 100%; min-width: 180px;")
          .form-group.col-12.mb-3(style="margin-left: 15px; margin-right: 15px; display: flex; justify-content: center")
            label.control_label(style="display: inline; margin-right: 7px") Model Status:
            label(style="margin-right: 4px; padding-top: 6px;" :class="{'label': true, 'label-danger': selectedModelStatus === 'Not Found', 'label-success': selectedModelStatus === 'MP', 'label-primary': selectedModelStatus === 'New Sample'}") {{ selectedModelStatus }}
            tooltip(effect="scale" placement="right" :content="modelStatusTooltip")
              span.glyphicon.glyphicon-question-sign(style="margin-top: 2px;")
          .form-group.col-12.mb-3(style="margin-left: 15px; margin-right: 15px;")
            label.control_label MT Bootloader:
            v-select(v-bind:value.sync='selectedBootloader' v-bind:options='bootloaderOptions' :disabled='bootloaderOptions.length === 0' placeholder='Not Selected' style="width: 100%; min-width: 180px;")
            button.btn.btn-primary.btn-block(v-if="selectedBootloader" @click="downloadBootloader" :disabled="!selectedBootloader" style="width: 100%; margin-top: 4px;")
              span.glyphicon.glyphicon-cloud-download
              span(style="margin-left: 4px;") Download Bootloader
            .text-center(v-if="selectedBootloaderMD5" style="margin-top: 8px; padding: 8px; background-color: #f8f9fa; border-radius: 4px; border: 1px solid #e9ecef;")
              span.text-muted(style="font-family: monospace; font-size: 12px;") MD5: {{ selectedBootloaderMD5 }}
          .form-group.col-12.mb-3(style="margin-left: 15px; margin-right: 15px;")
            label.control_label MT Firmware:
            v-select(v-bind:value.sync='selectedFirmware' v-bind:options='firmwareOptions' :disabled='isFirmwareDisabled || firmwareOptions.length === 0' placeholder='Not Selected' style="width: 100%; min-width: 180px;")
            button.btn.btn-primary.btn-block(v-if="selectedFirmware" @click="downloadFirmware" :disabled="!selectedFirmware" style="width: 100%; margin-top: 4px;")
              span.glyphicon.glyphicon-cloud-download
              span(style="margin-left: 4px;") Download Firmware
            .text-center(v-if="selectedFirmwareMD5" style="margin-top: 8px; padding: 8px; background-color: #f8f9fa; border-radius: 4px; border: 1px solid #e9ecef;")
              span.text-muted(style="font-family: monospace; font-size: 12px;") MD5: {{ selectedFirmwareMD5 }}
  modal(title="Help" effect="fade" :show.sync="showInstructions")
    .modal-body(slot='modal-body')
      .col-md-12.clearfix.col-centered
        .col-md-12.clearfix
          h5: strong Use Case 1: Downloads are available for both MT Bootloader and MT Firmware
          .alert.alert-info.mt-3(style="margin: 0 15px 10px 15px;") When the selected category and model are supported, #[strong both the MT Bootloader and MT Firmware will be available for download.]
          small.text-muted(style="margin-left: 15px") Example Screenshot:
          .clearfix: img.col-xs-12(src="../../../static/mt_download_use_case_1.png" alt="Downloads are available for both MT Bootloader and MT Firmware")
          hr(style="margin-top: 30px")
        .col-md-12.clearfix
          h5: strong Use Case 2: Model is currently under porting
          .alert.alert-info.alert-warning.mt-3(style="margin: 0 15px 10px 15px;") When the selected model is under porting, #[strong only the MT Bootloader will be available for download.] The firmware will be provided once porting is complete.
          small.text-muted(style="margin-left: 15px") Example Screenshot:
          .clearfix: img.col-xs-12(src="../../../static/mt_download_use_case_2.png" alt="Model is currently under porting")
          hr(style="margin-top: 30px")
        .col-md-12.clearfix(style="margin-bottom: 15px;")
          h5: strong Use Case 3: Model could not be found
          .alert.alert-info.alert-danger.mt-3(style="margin: 0 15px 5px 15px;") When the required model cannot be found in the list, #[strong please send a porting request to IS-PM and complete the porting registry to initiate support for your model.]
          small.text-muted(style="margin-left: 15px") Example Screenshot:
          .clearfix: img.col-xs-12(src="../../../static/mt_download_use_case_3.png" alt="Model could not be found")
    .modal-footer(slot='modal-footer')
      button.btn.btn-primary(@click='closeInstruction') Close
</template>

<script>
import { spinner, modal, tooltip } from 'vue-strap'
import SelectDisabled from '../common/SelectDisabled.vue'
import { getCustomForUI, getIconSrc, getDb, resolveDownloadUrl, naturalSorting } from '../../index.js'
import permissionsMixin from '../../mixins/permissionsMixin'
import _ from 'lodash'

export default {
  name: 'FirmwareDownload',
  mixins: [permissionsMixin],
  components: {
    'v-select': SelectDisabled,
    spinner,
    modal,
    tooltip
  },
  vuex: {
    getters: {
      user: state => state.user
    }
  },
  data () {
    return {
      selectedCategory: null,
      selectedModel: null,
      selectedBootloader: null,
      selectedFirmware: null,
      showWarning: false,
      isLoading: false,
      allBootloaderData: [],
      allFirmwareData: [],
      categoryOptions: [
        { label: 'OS2 Pro', value: 'os2_plus' },
        { label: 'OS5', value: 'os5' }
      ],
      modelOptions: [],
      bootloaderOptions: [],
      firmwareOptions: [],
      allProductModels: [], // will hold product/device data with .key

      // These two variables are used to prevent onChange loops.
      notChangeModel: false,
      notChangeCategory: false,

      showInstructions: false,
      modelStatusTooltip: `
        <div class="row" style="text-align: left;">
          <div class="col-xs-12 clearfix col-centered">
            <div class="row" style="margin-bottom: 7px;">
              <strong class="col-md-3">MP</strong>
              <div class="col-md-9">Mass Production.</div>
            </div>
            <div class="row" style="margin-bottom: 7px;">
              <strong class="col-md-3">New Sample</strong>
              <div class="col-md-9">This is a new model, please download MT bootloader.</div>
            </div>
            <div class="row">
              <strong class="col-md-3">Not Found</strong>
              <div class="col-md-9">Model not found, please contact Intrising PM to handle this model.</div>
            </div>
          </div>
        </div>
      `,
    }
  },
  computed: {
    // Models the current user is allowed to see. Mirrors the custom rules Products.vue
    // applies to the same `product` records: admin and Intrising see everything, the
    // Lantech accounts canSeeMtMenu lets in are limited to lantech_* products, and
    // anyone else sees nothing. The Lantech branch keys off the e-mail first so it
    // survives the window where onAuthStateChanged has reset state.user to { email }
    // and checkUserProfile has not dispatched role/custom back yet.
    visibleProductModels () {
      if (this.user.role === 'admin' || this.isIntrising) return this.allProductModels
      if (this.isLantechQA || _.startsWith(this.user.custom, 'lantech_')) {
        return this.allProductModels.filter(product =>
          Object.keys(product.custom || {}).some(custom => _.startsWith(custom, 'lantech_'))
        )
      }
      return []
    },
    selectedModelStatus () {
      const selectedProduct = this.visibleProductModels.find(product => product['.key'] === this.selectedModel)
      if (selectedProduct && selectedProduct.status === 'production') return 'MP'
      if (selectedProduct) return 'New Sample'
      return 'Not Found'
    },
    isFirmwareDisabled () {
      return this.selectedModelStatus !== 'MP'
    },
    selectedBootloaderMD5 () {
      if (!this.selectedBootloader) return ''
      const bootloader = this.allBootloaderData.find(item =>
        item.category === this.selectedCategory &&
        item.version === this.selectedBootloader
      )
      return bootloader ? bootloader.md5 : ''
    },
    selectedFirmwareMD5 () {
      if (!this.selectedFirmware) return ''
      const firmware = this.allFirmwareData.find(item =>
        item.category === this.selectedCategory &&
        item.version === this.selectedFirmware
      )
      return firmware ? firmware.programmingFileMd5 : ''
    }
  },
  methods: {
    getCustomForUI,
    getIconSrc,
    onCategoryChange () {
      if (!this.notChangeModel) {
        this.selectedModel = null
        this.notChangeCategory = true
      }
      this.updateModelOptions()
      this.updateBootloaderOptions()
      this.updateFirmwareOptions()
      this.notChangeModel = false

      // If the selected model does not match the selected category, clear the selected model.
      if (!this.modelOptions.some(opt => opt.value === this.selectedModel) || this.selectedCategory === null) {
        this.selectedModel = null
        this.notChangeCategory = false
      }
    },
    onModelChange () {
      // Find the selected model in visibleProductModels and set its category
      const found = this.visibleProductModels.find(m => m['.key'] === this.selectedModel)
      console.log('found', found)
      const newCategory = found ? found.category : this.selectedCategory
      if (!this.notChangeCategory) {
        this.selectedCategory = newCategory
        this.notChangeModel = true
      }
      this.updateModelOptions()
      this.updateBootloaderOptions()
      this.updateFirmwareOptions()
      this.notChangeCategory = false
    },
    updateModelOptions () {
      let filtered = this.visibleProductModels
      if (this.selectedCategory) {
        filtered = filtered.filter(item => item.category === this.selectedCategory)
      }
      const uniqueKeys = _.uniq(filtered.map(item => item['.key']))
      this.modelOptions = uniqueKeys.map(model => ({ label: model, value: model }))
    },
    updateBootloaderOptions () {
      if (!this.selectedCategory || !this.selectedModel) {
        this.bootloaderOptions = []
        this.selectedBootloader = null
        return
      }
      const filtered = naturalSorting(this.allBootloaderData.filter(item =>
        item.version &&
        item.category === this.selectedCategory &&
        (item.status === 'release' || item.status === 'production')
      ), 'version', 'desc')
      if (filtered.length === 0) {
        this.bootloaderOptions = []
        this.selectedBootloader = null
      } else {
        this.bootloaderOptions = filtered.map(item => ({
          label: item.status === 'release' ? `${item.version} (Under Testing)` : item.version,
          value: item.version,
          disabled: item.status === 'release'
        }))
        const firstEnabled = this.bootloaderOptions.find(opt => !opt.disabled)
        this.selectedBootloader = firstEnabled ? firstEnabled.value : null
      }
    },
    updateFirmwareOptions () {
      if (this.isFirmwareDisabled) {
        this.firmwareOptions = []
        this.selectedFirmware = null
        return
      }
      const filtered = naturalSorting(this.allFirmwareData.filter(item =>
        item.version &&
        item.category === this.selectedCategory &&
        (item.status === 'release' || item.status === 'production')
      ), 'version', 'desc')
      if (filtered.length === 0) {
        this.firmwareOptions = []
        this.selectedFirmware = null
      } else {
        this.firmwareOptions = filtered.map(item => ({
          label: item.status === 'release' ? `${item.version} (Under Testing)` : item.version,
          value: item.version,
          disabled: item.status === 'release'
        }))
        const firstEnabled = this.firmwareOptions.find(opt => !opt.disabled)
        this.selectedFirmware = firstEnabled ? firstEnabled.value : null
      }
    },
    downloadBootloader () {
      if (this.selectedBootloader) {
        const bootloader = this.allBootloaderData.find(item =>
          item.category === this.selectedCategory &&
          item.version === this.selectedBootloader
        )
        if (bootloader && bootloader.url) {
          this.handleDownload(bootloader.url)
        }
      }
    },
    downloadFirmware () {
      if (this.selectedFirmware) {
        const firmware = this.allFirmwareData.find(item =>
          item.category === this.selectedCategory &&
          item.version === this.selectedFirmware
        )
        if (firmware && firmware.programmingFileUrl) {
          this.handleDownload(firmware.programmingFileUrl)
        }
      }
    },
    handleDownload (url, e) {
      if (!url) return
      window.open(resolveDownloadUrl(url))
    },
    closeInstruction () {
      this.showInstructions = false
    }
  },
  watch: {
    // The user profile (role/custom) is dispatched after `authed`, so it can land
    // after ready() has already built the options. Rebuild once it arrives, and drop
    // a selection that is not visible to this user any more. The length check keeps a
    // transient empty profile from wiping a valid selection; visibility itself is
    // enforced by updateModelOptions and selectedModelStatus, not here.
    user () {
      const visible = this.visibleProductModels
      if (this.selectedModel && visible.length > 0 && !visible.some(p => p['.key'] === this.selectedModel)) {
        this.selectedModel = null
      }
      this.updateModelOptions()
      this.updateBootloaderOptions()
      this.updateFirmwareOptions()
    }
  },
  ready () {
    const load = (ref) => new Promise(resolve => {
      getDb().ref(ref).once('value', sn => {
        resolve(_.transform(sn.val() || {}, (result, value, key) => {
          result.push({ '.key': key, ...value })
        }, []))
      })
    })
    Promise.all([load('product'), load('mt-bootloader'), load('mt-firmware')]).then(([products, bootloaders, firmwares]) => {
      this.allProductModels = products.filter(m => m.category === 'os2_plus' || m.category === 'os5')
      this.allBootloaderData = bootloaders
      this.allFirmwareData = firmwares
      this.updateModelOptions()
      this.updateBootloaderOptions()
      this.updateFirmwareOptions()
    })
  }
}
</script>

<style lang="scss" scoped>
.title-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.function_bar {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
}

.form-group {
  margin-bottom: 15px;
}

.control_label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}

.device_icon {
  width: 30px;
  height: 30px;
  display: inline-block;
  margin-right: 10px;

  img {
    width: 30px;
    height: 30px;
  }
}

.alert {
  margin-top: 20px;
}

.panel {
  margin-top: 20px;
}

.table {
  margin-bottom: 0;
}

.btn-group {
  .btn {
    margin-right: 5px;
  }
}

.badge {
  color: white;
  padding: 5px 10px;
  border-radius: 3px;
}

::v-deep .dropdown-menu {
  width: 100% !important;
  min-width: 100% !important;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// FirmwareDownload.vue?66c8ed7e